/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../../../../nls/StringResources',
	'react',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit'
], function (_, stringResources, React, PropTypes, Toolkit) {

	const {
		Label,
		RadioGroup
	} = Toolkit;

	/**
	 * OperationSection
	 * Properties:
	 * - value - `value` of the current operation; can be null for none
	 * - values - array of `value`/`label` to show as options
	 * - onValueChange - callback for when the user selects a new value
	 */
	class OperationSection extends React.Component {
		static propTypes = {
			value: PropTypes.string,
			values: PropTypes.arrayOf(
				PropTypes.shape({
					value: PropTypes.string.isRequired,
					label: PropTypes.string.isRequired
				})
			),
			onValueChange: PropTypes.func.isRequired
		};

		render() {
			return (
				<div className="operationSection">
					<Label
						label={stringResources.get('topbottomOptionLabel')}
						type='caption'
					/>
					<RadioGroup
						direction='vertical'
						options={this.props.values}
						checked={this.props.value}
						onChange={v => this.props.onValueChange(v)}
						aria-labelledby={stringResources.get('topbottomSelectOption')} />
				</div>
			);
		}
	}

	return OperationSection;
});
